export { ReleaseToDeconPage } from './components/ReleaseToDeconPage';
export type {
  ReleaseToDeconStep,
  DetectedTray,
  ReleaseTrayStatus,
} from './types/release-to-decon';
